import { render, staticRenderFns } from "./PrinterActions.vue?vue&type=template&id=0065936f&"
import script from "./PrinterActions.vue?vue&type=script&lang=js&"
export * from "./PrinterActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports